

// import React, { useState, useEffect } from "react";
// import axios from "axios";

// const TestimonialSection = () => {
//   const [testimonials, setTestimonials] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     const fetchTestimonials = async () => {
//       try {
//         const response = await axios.get('/api/testimonials');
//         setTestimonials(response.data.data);
//         setLoading(false);
//       } catch (err) {
//         setError('Failed to fetch testimonials');
//         setLoading(false);
//         console.error('Error fetching testimonials:', err);
//       }
//     };

//     fetchTestimonials();
//   }, []);

//   if (loading) {
//     return <div className="text-center py-5">Loading testimonials...</div>;
//   }

//   if (error) {
//     return <div className="text-center py-5 text-danger">{error}</div>;
//   }

//   if (!testimonials || testimonials.length === 0) {
//     return <div className="text-center py-5">No testimonials available at the moment.</div>;
//   }

//   return (
//     // <>
//     //   <div className="testimonial-section-2 pt-100 pb-70">
//     //     <div className="container">
//     //       <div className="testimonial-content-2 owl-carousel owl-theme owl-loaded owl-drag">
//     //         <div className="owl-stage-outer">
//     //           <div
//     //             className="owl-stage"
//     //             style={{
//     //               transform: "translate3d(-2632px, 0px, 0px)",
//     //               transition: "1s",
//     //               width: 4606,
//     //             }}
//     //           >
//     //             {testimonials.map((testimonial, index) => (
//     //               <div
//     //                 key={testimonial._id || index}
//     //                 className="owl-item"
//     //                 style={{ width: 638, marginRight: 20 }}
//     //               >
//     //                 <div
//     //                   className="testimonial-item-2 aos-init aos-animate"
//     //                   data-aos="fade-up"
//     //                   data-aos-offset={100 + (index * 100)}
//     //                 >
//     //                   <div className="row g-0 align-items-center">
//     //                     <div className="col-lg-6 col-md-6">
//     //                       <div className="content">
//     //                         <p>"{testimonial.quote}"</p>
//     //                         <div className="info">
//     //                           <h4>{testimonial.authorName}</h4>
//     //                           <span>{testimonial.authorTitle}</span>
//     //                         </div>
//     //                       </div>
//     //                     </div>
//     //                     <div className="col-lg-6 col-md-6">
//     //                       <div className="image">
//     //                         <div className="quate-icon">
//     //                           <i className="bx bxs-quote-left" />
//     //                         </div>
//     //                         <img
//     //                           src={testimonial.authorImage || "assets/img/all-img/testimonial-1.png"}
//     //                           alt={testimonial.authorName}
//     //                         />
//     //                       </div>
//     //                     </div>
//     //                   </div>
//     //                 </div>
//     //               </div>
//     //             ))}
//     //           </div>
//     //         </div>
//     //         <div className="owl-nav disabled">
//     //           <button type="button" role="presentation" className="owl-prev">
//     //             <span aria-label="Previous">‹</span>
//     //           </button>
//     //           <button type="button" role="presentation" className="owl-next">
//     //             <span aria-label="Next">›</span>
//     //           </button>
//     //         </div>
//     //         <div className="owl-dots">
//     //           {testimonials.map((_, index) => (
//     //             <button key={index} role="button" className={`owl-dot ${index === 0 ? 'active' : ''}`}>
//     //               <span />
//     //             </button>
//     //           ))}
//     //         </div>
//     //       </div>
//     //     </div>
//     //   </div>
//     // </>

//     <><section className="testimonial-style-two">
//   <div className="auto-container">
//     <div className="sec-title centred mb_60">
//       <span className="sub-title">Testimonials</span>
//       <h2>Love from Users</h2>
//     </div>
//     <div className="two-item-carousel owl-carousel owl-theme owl-dots-none owl-nav-none">
//       <div className="testimonial-block-one">
//         <div className="inner-box">
//           <figure className="clients-logo"><img src="assets/images/clients/clients-13.png" alt /></figure>
//           <ul className="rating mb_15 clearfix">
//             <li><i className="icon-13" /></li>
//             <li><i className="icon-13" /></li>
//             <li><i className="icon-13" /></li>
//             <li><i className="icon-13" /></li>
//             <li><i className="icon-13" /></li>
//           </ul>
//           <p>Lorem ipsum dolor amet consectur elit adicing elit sed mod tempor incididunt enim minim veniam quison nosrud citation laboris nisiste aliquip comodo perspiatix unde omnis iste natus</p>
//           <div className="author-box">
//             <figure className="thumb-box"><img src="assets/images/resource/testimonial-2.png" alt /></figure>
//             <h4>Atalia Helena</h4>
//             <span className="designation">UI Designer</span>
//           </div>
//         </div>
//       </div>
//       <div className="testimonial-block-one">
//         <div className="inner-box">
//           <figure className="clients-logo"><img src="assets/images/clients/clients-13.png" alt /></figure>
//           <ul className="rating mb_15 clearfix">
//             <li><i className="icon-13" /></li>
//             <li><i className="icon-13" /></li>
//             <li><i className="icon-13" /></li>
//             <li><i className="icon-13" /></li>
//             <li><i className="icon-13" /></li>
//           </ul>
//           <p>Lorem ipsum dolor amet consectur elit adicing elit sed mod tempor incididunt enim minim veniam quison nosrud citation laboris nisiste aliquip comodo perspiatix unde omnis iste natus</p>
//           <div className="author-box">
//             <figure className="thumb-box"><img src="assets/images/resource/testimonial-3.png" alt /></figure>
//             <h4>William Brandon</h4>
//             <span className="designation">App Developer</span>
//           </div>
//         </div>
//       </div>
//     </div>
//   </div>
// </section>
// </>
//   );
// };

// export default TestimonialSection;

// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import OwlCarousel from "react-owl-carousel";
// import "owl.carousel/dist/assets/owl.carousel.css";
// import "owl.carousel/dist/assets/owl.theme.default.css";

// const TestimonialSection = () => {
//   const [testimonials, setTestimonials] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     const fetchTestimonials = async () => {
//       try {
//         const response = await axios.get("https://octoberfour-60f2c682a1d1.herokuapp.com/api/testimonials");
//         setTestimonials(response.data.data);
//         setLoading(false);
//       } catch (err) {
//         console.error(err);
//         setError("Failed to fetch testimonials");
//         setLoading(false);
//       }
//     };
//     fetchTestimonials();
//   }, []);

//   if (loading) return <div className="text-center py-5">Loading testimonials...</div>;
//   if (error) return <div className="text-center py-5 text-danger">{error}</div>;
//   if (!testimonials.length) return <div className="text-center py-5">No testimonials available.</div>;

//   // Owl Carousel options
//   const carouselOptions = {
//     items: 3,        // Show 3 testimonials at a time (col-lg-3)
//     margin: 30,
//     loop: true,
//     autoplay: true,
//     autoplayTimeout: 3000,
//     autoplayHoverPause: true,
//     dots: false,
//     nav: false,
//     responsive: {
//       0: { items: 1 },
//       576: { items: 1 },
//       768: { items: 2 },
//       992: { items: 3 },
//     },
//   };

//   return (
//     // <section className="testimonial-area pb-40 fix mb-5 pt-5" id="testimonials-sec">
//     //   <div className="container">
//     //     <div className="row justify-content-center mb-5">
//     //       <div className="col-xl-7 col-lg-8 text-center">
//     //         <span className="section-subtitle tp_fade_left text-black">Testimonials</span>
//     //         <h2 className="section-title tp_title_slideup mb-0 text-black">
//     //            Reviews for Our Satisfied Clients
//     //         </h2>
//     //       </div>
//     //     </div>

//     //     <OwlCarousel className="owl-theme" {...carouselOptions}>
//     //       {testimonials.map((t, index) => (
//     //         <div className="testimonial-block-one shadow-sm p-5 mb-5 bg-white rounded" key={t._id || index}>
//     //           <div className="inner-box text-center">
//     //             <p>{t.quote || "Lorem ipsum dolor sit amet..."}</p>
//     //             <div className="author-box mt-3">
//     //               <figure className="thumb-box mb-2">
//     //                 <img
//     //                   src={t.authorImage || "assets/images/resource/testimonial-2.png"}
//     //                   alt={t.authorName || "Anonymous"}
//     //                   style={{
//     //                     width: "60px",
//     //                     height: "60px",
//     //                     objectFit: "cover",
//     //                     borderRadius: "50%",
//     //                     margin: "0 auto",
//     //                   }}
//     //                 />
//     //               </figure>
//     //               <h5>{t.authorName || "Anonymous"}</h5>
//     //               <span className="designation">{t.authorTitle || "User"}</span>
//     //             </div>
//     //           </div>
//     //         </div>
//     //       ))}
//     //     </OwlCarousel>
//     //   </div>
//     // </section>

//     <>  <section id="feedback" className="feedback-area py-130 rel z-1">
//   <div className="container">
//     <div className="row justify-content-center">
//       <div className="col-xl-6 col-lg-8">
//         <div className="section-title text-center mb-40 wow fadeInUp delay-0-2s">
//           <span className="sub-title style-two mb-20">Clents Feedback</span>
//           <h2>3,000+ Positive reviews by our satisfied clients</h2>
//         </div>
//       </div>
//     </div>
//     <div className="feedback-active">
//       <div className="feedback-item wow fadeInUp delay-0-2s">
//         <div className="author-logo">
//           <i className="far fa-quote-right" />
//           <img src="assets/images/feedback/logo1.png" alt="Logo" />
//         </div>
//         <h4>On the other hand denounes with indignwy</h4>
//         <p>Sed ut perspiciatis unde omnis natus error voluptatem accusantium dolore laudantuce totam rem aperiam eaque inventore</p>
//         <div className="feedback-author">
//           <img src="assets/images/feedback/author1.jpg" alt="Author" />
//           <div className="content">
//             <h5>Jonathan B. Bohnert</h5>
//             <span>CEO &amp; Founder</span>
//           </div>
//         </div>
//       </div>
//       <div className="feedback-item wow fadeInUp delay-0-4s">
//         <div className="author-logo">
//           <i className="far fa-quote-right" />
//           <img src="assets/images/feedback/logo2.png" alt="Logo" />
//         </div>
//         <h4>Custom programming fores most complex functions</h4>
//         <p>Sed ut perspiciatis unde omnis natus error voluptatem accusantium dolore laudantuce totam rem aperiam eaque inventore</p>
//         <div className="feedback-author">
//           <img src="assets/images/feedback/author2.jpg" alt="Author" />
//           <div className="content">
//             <h5>Nicholas R. Gomez</h5>
//             <span>Medical Officers</span>
//           </div>
//         </div>
//       </div>
//       <div className="feedback-item wow fadeInUp delay-0-6s">
//         <div className="author-logo">
//           <i className="far fa-quote-right" />
//           <img src="assets/images/feedback/logo3.png" alt="Logo" />
//         </div>
//         <h4>We use strategic marketing tactics be proven work.</h4>
//         <p>Sed ut perspiciatis unde omnis natus error voluptatem accusantium dolore laudantuce totam rem aperiam eaque inventore</p>
//         <div className="feedback-author">
//           <img src="assets/images/feedback/author3.jpg" alt="Author" />
//           <div className="content">
//             <h5>James R. Lawrence</h5>
//             <span>Junior Manager</span>
//           </div>
//         </div>
//       </div>
//       <div className="feedback-item wow fadeInUp delay-0-2s">
//         <div className="author-logo">
//           <i className="far fa-quote-right" />
//           <img src="assets/images/feedback/logo1.png" alt="Logo" />
//         </div>
//         <h4>On the other hand denounes with indignwy</h4>
//         <p>Sed ut perspiciatis unde omnis natus error voluptatem accusantium dolore laudantuce totam rem aperiam eaque inventore</p>
//         <div className="feedback-author">
//           <img src="assets/images/feedback/author1.jpg" alt="Author" />
//           <div className="content">
//             <h5>Jonathan B. Bohnert</h5>
//             <span>CEO &amp; Founder</span>
//           </div>
//         </div>
//       </div>
//       <div className="feedback-item wow fadeInUp delay-0-2s">
//         <div className="author-logo">
//           <i className="far fa-quote-right" />
//           <img src="assets/images/feedback/logo2.png" alt="Logo" />
//         </div>
//         <h4>Custom programming fores most complex functions</h4>
//         <p>Sed ut perspiciatis unde omnis natus error voluptatem accusantium dolore laudantuce totam rem aperiam eaque inventore</p>
//         <div className="feedback-author">
//           <img src="assets/images/feedback/author2.jpg" alt="Author" />
//           <div className="content">
//             <h5>Nicholas R. Gomez</h5>
//             <span>Medical Officers</span>
//           </div>
//         </div>
//       </div>
//       <div className="feedback-item wow fadeInUp delay-0-2s">
//         <div className="author-logo">
//           <i className="far fa-quote-right" />
//           <img src="assets/images/feedback/logo3.png" alt="Logo" />
//         </div>
//         <h4>We use strategic marketing tactics be proven work.</h4>
//         <p>Sed ut perspiciatis unde omnis natus error voluptatem accusantium dolore laudantuce totam rem aperiam eaque inventore</p>
//         <div className="feedback-author">
//           <img src="assets/images/feedback/author3.jpg" alt="Author" />
//           <div className="content">
//             <h5>James R. Lawrence</h5>
//             <span>Junior Manager</span>
//           </div>
//         </div>
//       </div>
//     </div>
//   </div>
//   <div className="feedback-shape one">
//     <img src="assets/images/feedback/man1.jpg" alt="Man Shape" />
//   </div>
//   <div className="feedback-shape two">
//     <img src="assets/images/feedback/man2.jpg" alt="Man Shape" />
//   </div>
// </section>
// </>
//   );
// };

// export default TestimonialSection;



import React, { useState, useEffect } from "react";
import axios from "axios";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";

const TestimonialSection = () => {
  const [testimonials, setTestimonials] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch Testimonials from API
  useEffect(() => {
    const fetchTestimonials = async () => {
      try {
        const response = await axios.get("https://octoberfour-60f2c682a1d1.herokuapp.com/api/testimonials");
        setTestimonials(response.data.data || []);
        setLoading(false);
      } catch (err) {
        console.error(err);
        setError("Failed to fetch testimonials");
        setLoading(false);
      }
    };
    fetchTestimonials();
  }, []);

  if (loading) return <div className="text-center py-5">Loading testimonials...</div>;
  if (error) return <div className="text-center py-5 text-danger">{error}</div>;
  if (!testimonials.length) return <div className="text-center py-5">No testimonials available.</div>;

  const carouselOptions = {
    items: 4,
    margin: 24,
    loop: true,
    autoplay: true,
    autoplayTimeout: 3000,
    autoplayHoverPause: true,
    dots: true,
    nav: false,
    smartSpeed: 800,
    responsive: {
      0: { items: 1 },
      576: { items: 2 },
      768: { items: 2 },
      992: { items: 3 },
      1200: { items: 4 },
    },
  };

  return (
    <section>
      <div className="cs_height_120 cs_height_lg_70" />
      <div className="container">
        <div className="cs_section_heading cs_style_1 text-center cs_mb_55">
          <h2 className="cs_fs_50 mb-0 wow fadeInDown">
            Customer Reviews and <br /> Success Stories
          </h2>
        </div>
      </div>

      {/* Owl Carousel Wrapper */}
      <div className="cs_slider cs_style_1 cs_slider_gap_24 ">
        <OwlCarousel className="owl-theme" {...carouselOptions}>
          {testimonials.map((t, index) => (
            <div className="cs_slide" key={t._id || index}>
              <div className="cs_testimonial cs_style_1 cs_radius_15 position-relative">
                <div className="cs_avatar cs_style_1 cs_mb_41">
                  <span className="cs_avatar_icon cs_center cs_radius_100">
                    <img
                      src={t.authorImage || "assets/img/avatar-1.jpg"}
                      alt={t.authorName || "Anonymous"}
                    />
                  </span>
                  <div className="cs_avatar_info">
                    <h3 className="cs_fs_21 fw-normal">
                      {t.authorName || "Anonymous"}
                    </h3>
                    <p className="mb-0">{t.authorTitle || "Client"}</p>
                  </div>
                </div>
                <blockquote>
                  {t.quote ||
                    "Gosaas has completely transformed how we manage projects at our company. The intuitive interface makes it easy for everyone to get on board."}
                </blockquote>
                <div className="cs_rating" data-rating={t.rating || 5}>
                  <div className="cs_rating_percentage" />
                </div>
                <span className="cs_quote_icon position-absolute"></span>
              </div>
            </div>
          ))}
        </OwlCarousel>

        <div className="cs_height_70 cs_height_lg_50" />
        <div className="cs_pagination cs_style_1 wow fadeInUp" />
      </div>
     
    </section>
  );
};

export default TestimonialSection;



